import {buildDraftComment} from '../../../helpers/models/commentHelpers';
import {AnnotationModel} from '../../../models/api/annotationModel';
import {CommentModel} from '../../../models/api/commentModel';
import {MessageModel} from '../../../models/api/messageModel';
import {findCommentComposer} from '../../../services/composers';
import {ThunkAction} from '../../appThunk';
import {makeGetDraftComments} from '../conversations/conversationsSelectors';
import {getConversations} from '../dataSelectors';
import {getUserId} from '../teammates/teammatesSelectors';
import {saveCommentAsyncAction} from './saveCommentActions';

export function highlightInMessageAction(
  message: MessageModel,
  annotation: AnnotationModel,
  activityId: number,
) {
  return highlightAction(message.conversationId, annotation, activityId);
}

export function highlightInCommentAction(
  comment: CommentModel,
  annotation: AnnotationModel,
  activityId: number,
) {
  return highlightAction(comment.conversationId, annotation, activityId);
}

function highlightAction(
  conversationId: number,
  annotation: AnnotationModel,
  activityId: number,
): ThunkAction {
  return async (dispatch, getState) => {
    const state = getState();
    const conversations = getConversations(state);

    const conversation = conversations[conversationId];
    if (!conversation) {
      return;
    }

    const getDraftComments = makeGetDraftComments(() => conversation);
    const draftComments = getDraftComments(state, {});

    const commentUrlBuilder = (uid: string) => `${conversation.url}/comments/${uid}`;
    const highlightComment =
      draftComments[0] ||
      buildDraftComment({
        urlBuilder: commentUrlBuilder,
        authorId: getUserId(state),
        conversationId: conversation.id,
      });

    dispatch(
      saveCommentAsyncAction(highlightComment, {
        newAnnotation: annotation,
        newReferencedActivityId: activityId,
      }),
    );

    const composer = findCommentComposer(conversationId);

    if (!composer) {
      return;
    }

    // We are calling setTimeout because there's a bug after revising a text selection, where we fail to focus on the
    // comment composer editor reliably (which adds an extra click to the quote message/comment flow). setTimeout is
    // a hack working around what is likely a race condition.
    setTimeout(() => {
      composer.focus();
    }, 0);
  };
}
